import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import buttonStyle from "./buttonStyle";
import {
    FaHome,
    FaLink,
    FaTrash,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { BaseButton } from "../../componentes/baseComponents/BaseButton"
import { BaseDialog } from "../../componentes/baseComponents/base-dialog/BaseDialog"
import ProductGroupService from "./ProductGroupService";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";

function reducer(state, action) {
    switch (action.type) {
        case "update": {
            return { ...state, ...action.data }
        }
        case "clear": {
            return {
                ...initialState,
                open: true
            };
        }
        case "error": {
            return {
                ...state,
                success: false,
                error: true,
                message: action.message
            };
        }
        case "close_alert": {
            return {
                ...state,
                success: false,
                error: false
            };
        }
        case "open_dialog": {
            return {
                ...state,
                open: true
            };
        }
        case "close_dialog": {
            return initialState;
        }
        case "success": {
            return {
                ...state,
                success: true,
                error: false,
                message: action.message
            };
        }
        case "close_confirmation_dialog_success": {
            const rowToRemove = state.idDeletion;
            const newRows = state.rows.filter(row => row.idEan !== rowToRemove);

            return {
                ...state,
                confirmationDialog: false,
                idDeletion: 0,
                success: true,
                error: false,
                rows: newRows
            };
        }
        case "close_confirmation_dialog_error": {
            return {
                ...state,
                confirmationDialog: false,
                idDeletion: 0,
                success: false,
                error: true
            };
        }
        default:
            throw new Error(`Invalid reducer action type: ${action.type}!`);
    }
}

const initialState = {
    open: false,
    success: false,
    message: "",
    error: false,
    id: 0,
    description: "",
    status: 1,
    rows: [],
    confirmationDialog: false,
};

const columns = (t) => [
    {
        field: "id",
        headerText: t("id"),
        textAlign: 'center'
    },
    {
        field: "description",
        headerText: t("description"),
        textAlign: 'center'
    },
    {
        field: "status",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
        },
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
    
    
];

const ProductGroup = ({ _idProduto }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");
    const buttonClass = buttonStyle();

    const [state, dispatch] = useReducer(reducer, initialState);
    const { open, success, error, message, id, description, status, rows} = state;
    
    function openDialog() {
        dispatch({ type: "open_dialog" });
    }

    function closeDialog() {
        dispatch({ type: "close_dialog" });
    }

    function setError(message) {
        dispatch({ type: "error", message });
    }

    function setSuccess(message) {
        dispatch({ type: "success", message });
    }

    function handleCloseAlert() {
        dispatch({ type: "close_alert" });
    }

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } })
    }

    function handleClear() {
        dispatch({ type: "clear" });
    }

    const handleClickGrid = (rowData) => {
        dispatch({
            type: 'update', data: {
                id: rowData.id,
                description: rowData.description,
                status: rowData.status
            }
        })
    }

    function handleSave() {

        ProductGroupService
            .save({ ...state, userId: userId, description: description, status: status, id: state.id })
            .then((response) => {
                dispatch({ type: 'success' })
                handleSearchProduct()
            })
            .catch(() => setError(t("saveError")));
    }

    const handleSearchProduct = () => {
        let request = { ...state }
        ProductGroupService
            .get(request)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
                console.log(rows)
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    };

    return (
        <>

            <BaseButton onClick={openDialog} label={t("productGroup").toUpperCase()} className={buttonClass.blackButton} />

            <CustomAlert
                success={success}
                error={error}
                message={message}
                handleCloseAlert={handleCloseAlert}
                snackbar
                autoClose
            />

            <BaseDialog
                open={open}
                onClose={closeDialog}
                maxWidth="md"
                fullWidth
                title={t("productGroup")}
                content={
                    <>
                        <GridInputRow>
                            <Grid item xs={7} sm={7} md={7}>
                                <InputField
                                    iconLabelSwitch={
                                        <IconLabelSwitch name="description" labelName="description" />
                                    }
                                    name="description"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={description}
                                    length={50}
                                    error={error && description === ""}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4}>
                                <DefaultAutocomplete
                                    name={"status"}
                                    onChange={handleChange}
                                    value={status}
                                    label={t("status")}
                                    defaultSize
                                    items={[
                                        { id: 0, name: t("canceled"), status: 1 },
                                        { id: 1, name: t("active"), status: 1 },
                                        { id: 2, name: t("all"), status: 1 },
                                    ]}
                                />
                            </Grid>
                        </GridInputRow>
                        <GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClear}
                                onClickSearch={handleSearchProduct}
                                onClickSave={handleSave}
                            />
                        </GridInputRow>

                        {rows.length > 0 ? (
                            <DefaultScreenAccordion
            
                                fields={
                                    <DefaultDatagrid
                                        columns={columns(t)}
                                        dataSource={rows}
                                        cellSelected={(args, grid) => handleClickGrid(args.data)}
                                        allowPaging={true}
                                    />
                                } />
                        ) : null}

                    </>
                }
            />
        </>
    );
};

export default ProductGroup;
